import { Component, EventEmitter, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { merge, Subject } from 'rxjs';
import { debounceTime, filter, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';

import { PagedResult, Recurrence, RecurrenceDialogData } from '@interfaces';
import { RecurrenceService } from 'app/main/recurrences/services/recurrence.service';

@Component({
  selector: 'tab-occurrences',
  templateUrl: './tab-occurrences.component.html',
})
export class TabOccurrencesComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  public resultsLength = 0;
  public recurrence: Recurrence;
  public occurrences: Array<any> = [];
  private subscriptions = new Subject<void>();
  public reload: EventEmitter<boolean> = new EventEmitter();
  public displayedColumns = ['scheduledDate', 'number', 'company', 'status'];
  public query: any;
  public isLoading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: RecurrenceDialogData,
    private fuseProgressBarService: FuseProgressBarService,
    private recurrenceService: RecurrenceService
  ) {
    this.recurrence = this.dialogData.recurrence;

    this.query = {
      recurrenceId_in: [this.recurrence.id]
    };
  }

  ngOnDestroy(): void {
    this.subscriptions.next();
    this.subscriptions.complete();
  }

  ngOnInit(): void {
    this.sort.active = 'scheduledDate';
    this.sort.direction = 'desc';

    merge(
      this.sort.sortChange,
      this.paginator.page,
      this.reload.pipe(tap(() => this.paginator.firstPage()))
    )
      .pipe(
        takeUntil(this.subscriptions),
        startWith({}),
        filter(() => !!this.recurrence.id),
        debounceTime(500),
        switchMap(() => {
          this.isLoading = true;
          this.fuseProgressBarService.show();
          return this.searchOccurrences();
        }),
      )
      .subscribe((data) => {
        this.fuseProgressBarService.hide();
        this.resultsLength = data.totalCount;
        this.occurrences = data.items;
        this.isLoading = false;
      });
  }

  searchOccurrences(): Promise<PagedResult> {
    return this.recurrenceService.listOccurrences({
      where: this.query,
      options: {
        offset: this.paginator.pageIndex * this.paginator.pageSize,
        limit: this.paginator.pageSize,
        orderBy: `${this.sort.active}_${this.sort.direction}`
      },
    });
  }
}
